import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  head: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  body: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "16px",
  },
  comment: {
    color: theme.custom.color.blackRussian,
    fontSize: "16px",
    //fontWeight: "bold",
    letterSpacing: 0.1,
    lineHeight: "24px",
    padding: theme.spacing(1.5, 0, 0.5, 0),
  },
  textarea: {
    height: "70px",
    backgroundColor: "#f7f7f7",
    padding: "15px 10px",
    width: "100%",
    fontSize: "14px",
    letterSpacing: 0,
    lineHeight: "20px",
    outline: "none",
    color: theme.custom.color.blackRussian,
    resize: "none",
    border: "none",
    overflow: "auto",
    fontFamily: "Open Sans",
  },
  icon: {
    fontSize: "large",
  },
  iconAlign: {
    paddingLeft: theme.spacing(1),
  },
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(7),
    display: "flex",
    flexDirection: "column",
  },
  hide: {
    display: "none",
  },
}));
